import * as defaultImport from "@splunk/visualizations/ChoroplethSvg";
export * from "@splunk/visualizations/ChoroplethSvg";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
